const BASE_URL = 'https://sistema.flartekmx.com/api.php';

const API_URLS = {
  LOGIN: `${BASE_URL}/login`,
  CREATE_USER: `${BASE_URL}/users`,
  OBJECTTYPES: `${BASE_URL}/tipos_objetos`,
  GET_USER: `${BASE_URL}/users`,
  TICKETS: `${BASE_URL}/notas`,
  SERVICES: `${BASE_URL}/servicios`,
  DRONES: `${BASE_URL}/drones`,
  ACCESORIES: `${BASE_URL}/accesorios`,
  PARTS: `${BASE_URL}/partes`,
  COTIZATIONS: `${BASE_URL}/cotizaciones`,
  DRONES_PARTS: `${BASE_URL}/drones_partes`,
  DRONES_ACCESORIES: `${BASE_URL}/drones_accesorios`,
  PROCESS: `${BASE_URL}/proceso`,
  UPDATE_PASSWORD: `${BASE_URL}/update_password`,
  PRINT_FOLIO: `${BASE_URL}/print_cotizacion`,
  PRINT_NOTA: `${BASE_URL}/print_nota`,
  FOLIO: `${BASE_URL}/folios`,
  GET_USERS: `${BASE_URL}/users`,
  CLAIM_TICKETS: `${BASE_URL}/notas`,
  UPDATE_USER: `${BASE_URL}/users`,
  INVENTORY: `${BASE_URL}/inventario`,
  DELETE_USER: `${BASE_URL}/users`,
  CLIENTS : `${BASE_URL}/clientes`,
  BUDGETS : `${BASE_URL}/cotizaciones`,
  ADDRESS : `${BASE_URL}/direcciones`,
  BUDGETOBJECT : `${BASE_URL}/objetocotizacion`,
  CLAIMOBJECT : `${BASE_URL}/objetocliente`,
  INVENTORY: `${BASE_URL}/inventario`,
};

// Exportar tanto el objeto completo como las URLs individuales
export const LOGIN = API_URLS.LOGIN;
export const CREATE_USER = API_URLS.CREATE_USER;
export const GET_USER = API_URLS.GET_USER;
export const TICKETS = API_URLS.TICKETS;
export const SERVICES = API_URLS.SERVICES;
export const DRONES = API_URLS.DRONES;
export const ACCESORIES = API_URLS.ACCESORIES;
export const PARTS = API_URLS.PARTS;
export const COTIZATIONS = API_URLS.COTIZATIONS;
export const DRONE_PARTS = API_URLS.DRONE_PARTS;
export const PRINT_FOLIO = API_URLS.PRINT_FOLIO;
export const FOLIO = API_URLS.FOLIO;
export const GET_USERS = API_URLS.GET_USERS;
export const CLAIM_TICKETS = API_URLS.CLAIM_TICKETS;
export const UPDATE_USER = API_URLS.UPDATE_USER;
export const DELETE_USER = API_URLS.DELETE_USER;
export const CLIENTS = API_URLS.CLIENTS;
export const ADDRESS = API_URLS.ADDRESS;
export const BUDGETOBJECT = API_URLS.BUDGETOBJECT;
export const CLAIMOBJECT = API_URLS.CLAIMOBJECT;
export const INVENTORY = API_URLS.INVENTORY;

export default API_URLS;